var _circle, _circle2, _circle3, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedux(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 64,
    width: 64,
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 19,
    r: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 36,
    r: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 30,
    r: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.17,21.488c-4.326-2.595-9.124-3.766-13.319-3.375C24.939,18.395,25,18.689,25,19c0,0.41-0.083,0.8-0.232,1.156 c3.832-0.444,8.302,0.606,12.374,3.047c7.894,4.732,11.87,12.983,8.863,18.392c-1.074,1.931-2.948,3.302-5.419,3.963 c-3.462,0.928-7.714,0.358-11.773-1.478c-0.586,0.471-1.206,0.917-1.844,1.348c3.325,1.679,6.844,2.569,10.094,2.569 c1.411,0,2.771-0.167,4.041-0.507c3.007-0.805,5.307-2.507,6.65-4.923C51.278,36.225,46.979,26.769,38.17,21.488z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24,2c-7.168,0-13,8.293-13,18.487c0,5.551,1.75,10.501,4.485,13.887c0.361-0.558,0.904-0.979,1.544-1.199 C14.58,30.151,13,25.603,13,20.487C13,11.396,17.935,4,24,4c5.419,0,9.924,5.909,10.825,13.65c0.707,0.269,1.408,0.573,2.103,0.907 C36.247,9.267,30.71,2,24,2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34,33c-0.481,0-0.929-0.124-1.332-0.325c-1.423,3.733-4.576,7.476-8.99,10.122c-4.75,2.849-10.081,3.881-14.263,2.761 c-2.472-0.662-4.346-2.032-5.419-3.963c-2.542-4.573-0.081-11.168,5.506-15.961c-0.145-0.751-0.257-1.519-0.339-2.301 c-6.964,5.44-10.061,13.573-6.915,19.233c1.343,2.416,3.643,4.118,6.65,4.923c1.271,0.34,2.63,0.507,4.041,0.507 c3.8,0,7.972-1.208,11.768-3.484c4.959-2.973,8.433-7.267,9.932-11.584C34.432,32.973,34.22,33,34,33z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedux);
export default __webpack_public_path__ + "static/media/redux.11f0ee1ba31e6c27e08fe3438a61376e.svg";
export { ForwardRef as ReactComponent };